import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { renderChildren } from '../../BlockRenderer/renderChildren.js';
import { useRouter } from '../../hooks/useRouter.js';
import { BlockWrapper } from '../../ui-kit/BlockWrapper.js';
import { UniBlock } from '../../UniBlock/UniBlock.js';
import { adjustSrc } from '../../utils/adjustSrc.js';
import { getBorderStyle } from '../../utils/getBorderStyle.js';
import { getInnerPadding } from '../../utils/getInnerPadding.js';
import { style } from '../../utils/style.js';
import { gapStyles } from '../HorizontalLayout/gapStyles.js';
export const VerticalLayout = UniBlock(({ className = '', padding = 'p-0', gap = '', isInnerPadding = true, version = 'transparent', isTheme = false, isCardBorder = false, image, ...rest }) => {
    const router = useRouter();
    return (_jsx(BlockWrapper, { className: style('relative flex flex-col', gapStyles[gap], image?.src ? 'bg-right-bottom bg-no-repeat' : '', className), ...(image?.src
            ? { style: { backgroundImage: `url(${adjustSrc(router)(image?.src)})` } }
            : {}), padding: padding, version: version, isTheme: isTheme, ...rest, children: renderChildren({
            ...rest,
            extraProps: {
                className: style('w-full', getBorderStyle(isCardBorder)),
                ...getInnerPadding(isInnerPadding),
            },
        }) }));
}, { childrenTypes: [] });
//# sourceMappingURL=VerticalLayout.js.map